import { useAuth } from "@/lib/auth";
import { ROLE_LABELS } from "@/lib/api";

export default function StaffProfile() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className="px-5 pt-6 pb-12 max-w-md mx-auto">
      <p className="text-xs tracking-[0.3em] uppercase text-[#E50914]">Profile</p>
      <h1 className="font-display text-3xl tracking-tight">{user.name}</h1>
      <p className="text-sm text-zinc-400 mt-1 font-mono">{user.employee_id}</p>

      <div className="mt-6 bg-[#16161C] border border-[#2D2D35] rounded-md p-5 space-y-4">
        <Row label="Email" value={user.email} />
        <Row label="Role" value={ROLE_LABELS[user.role]} />
        <Row label="Designation" value={user.designation || "—"} />
        <Row label="Department" value={user.department || "—"} />
        <Row label="Shift" value={user.shift} />
        <Row label="Joining" value={user.joining_date?.slice(0, 10)} />
        <Row label="Contact" value={user.contact || "—"} />
        <Row label="Emergency" value={user.emergency_contact || "—"} />
        <Row label="Bank A/c" value={user.bank_account || "—"} />
        <Row label="UPI" value={user.upi_id || "—"} />
        <Row label="Monthly Salary" value={user.monthly_salary ? `₹ ${Number(user.monthly_salary).toLocaleString()}` : "—"} />
        <Row label="Reporting To" value={user.reporting_manager || "—"} />
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex items-center justify-between border-b border-[#2D2D35]/60 pb-3 last:border-0 last:pb-0">
      <span className="text-[10px] uppercase tracking-widest text-zinc-500">{label}</span>
      <span className="text-sm font-mono">{value}</span>
    </div>
  );
}
